import { ApiMethod, JSONObject } from '../../types/types';
import { apiRequest } from './apiRequest';
import { detailedApiMethodFetcher } from './fetchers/detailedApiMethodFetcher';
import { fetcher } from './fetchers/fetcher';
import { resolveTemplate } from '../../utils/json/resolveTemplate';
import { resolveApiPath } from './resolveApiPath';
import { HandlerRequestContext } from '../types/types';
import { ResponseActionHandler } from '../../types/context';

// Shared fetch: resolves the apiMethod template, makes the HTTP call, and
// returns the result already remapped by the response template when defined.
export const fetchApiMethod = async (
  apiMethod: ApiMethod,
  context: HandlerRequestContext,
  getResponseActionHandler?: (
    name: string
  ) => ResponseActionHandler | undefined,
  forceHeader?: string
): Promise<unknown> => {
  if (typeof apiMethod === 'string') {
    const { apiUrl } = await resolveTemplate({ apiUrl: apiMethod }, context);

    return await fetcher(
      resolveApiPath(apiUrl),
      'GET',
      context.sessionId ?? null,
      forceHeader,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      true
    );
  }

  return await apiRequest(
    apiMethod,
    context,
    (resolvedMethod) => detailedApiMethodFetcher(resolvedMethod, forceHeader),
    getResponseActionHandler
  );
};
